import React, { useEffect } from "react";
import CountUp from "react-countup";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Aos from "aos";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import ArabicBreadcrumbs from "../common/ArabicBreadcrumbs";
import Link from "antd/es/typography/Link";
import { setMeta } from "../../core/data/utils/meta";
import { CLIENT_BASE_PATH } from "../../environment";

const ArAbout = () => {

  useEffect(() => {
    const canonicalUrl = `${CLIENT_BASE_PATH}/ar/about`;
    setMeta(
      "عن الحرمين كاب | خدمة تاكسي عمرة موثوقة في السعودية",
      "تعرف على الحرمين كاب، خدمة تاكسي سعودية موثوقة للعمرة والحج ونقل المطار واستقبال الفنادق ورحلات الزيارة.",
      canonicalUrl,
      undefined,
      {
        locale: "ar",
        alternateUrl: `${CLIENT_BASE_PATH}/about`,
      }
    );
  }, []);

  const testimonials = [
    {
      id: 1,
      name: "Aisha Khan",
      image: "/assets/img/profiles/avatar-02.jpg",
      rating: 5.0,
      review:
        "كانت رحلة العمرة مع هذه الخدمة نعمة حقيقية. الراحة والاحترام الذي شعرنا به طوال الرحلة تجاوز توقعاتي. لقد جعلوا رحلتنا الروحية ذكرى لا تُنسى.",
    },
    {
      id: 2,
      name: "Mohammed Al-Farsi",
      image: "/assets/img/profiles/avatar-03.jpg",
      rating: 5.0,
      review:
        "من بداية رحلة العمرة حتى عودتنا إلى المنزل، كان التفاني والاهتمام من الفريق استثنائياً. فهمهم لحاجاتنا جعل كل شيء سهلاً وسلساً. أوصي بشدة بخدماتهم.",
    },
    {
      id: 3,
      name: "Bilal Ahmad",
      image: "/assets/img/profiles/avatar-04.jpg",
      rating: 5.0,
      review:
        "رحلة العمرة الروحية قريبة من قلبي، واختيارهم كشريك سفر جعلها أكثر تميزاً. اهتمامهم بكل تفصيل صغير جعلنا نركز على صلاتنا ومناسكنا. جزاكم الله خيراً على تجربة لا تُنسى.",
    },
    {
      id: 4,
      name: "Fatima Zubair",
      image: "/assets/img/profiles/avatar-06.jpg",
      rating: 5.0,
      review:
        "لم تكن رحلة العمرة مجرد سفر، بل تجربة مؤثرة بعمق بفضل خدمتهم المتميزة. تم الحفاظ على الأجواء الروحية طوال الرحلة، مما جعلها رحلة حج هادئة. أنا ممتنة جداً لطيبتهم ومهنيتهم.",
    },
    {
      id: 5,
      name: "Ibrahim Yusuf",
      image: "/assets/img/profiles/avatar-07.jpg",
      rating: 5.0,
      review:
        "كشخص أدى العمرة عدة مرات، يمكنني أن أقول بثقة إن خدمتهم مميزة. احترامهم للممارسات الثقافية والدينية واضح، وتنظيمهم جعل رحلتنا سلسة وخالية من القلق.",
    },
    {
      id: 6,
      name: "Noor Al-Huda",
      image: "/assets/img/profiles/avatar-07.jpg",
      rating: 5.0,
      review:
        "جعل فريقهم رحلة عمرتنا تجربة غنية روحياً. الاحترام والنظافة والالتزام بالمواعيد التي حافظوا عليها طوال رحلتنا كانت مثيرة للإعجاب. كان من الشرف أن نسافر معهم.",
    },
  ];
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: 2,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
  }, []);
  return (
    <>
      <ArabicBreadcrumbs title="من نحن" />
      <section className="section about-sec">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6" data-aos="fade-down">
              <div className="about-img">
                <div className="about-exp">
                  <span>أفضل خدمة تاكسي</span>
                </div>
                <div className="abt-img">
                  <ImageWithBasePath
                    src="/assets/img/bg/aboutus.jpg"
                    className="img-fluid"
                    alt="من نحن"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-down">
              <div className="about-content">
                <h6>عن خدمة الحرمين كاب</h6>
                <p>
                  مرحباً بكم في الحرمين، رفيقكم الموثوق في الرحلة المقدسة عبر قلب المملكة العربية السعودية.
                  تأسست الحرمين كاب برؤية تسهيل تجربة سفر سلسة ومريحة وغنية روحياً، وتتخصص في تقديم
                  حلول نقل من الطراز الأول للمعتمرين والزوار إلى مدينتي مكة والمدينة المقدستين.
                </p>
                <b>مهمتنا</b>
                <p>
                  في الحرمين، نؤمن بأن رحلة الحج أو العمرة أكثر من مجرد سفر؛ إنها تجربة يجب الاحتفاظ بها وتذكرها.
                  مهمتنا هي ضمان أن كل مسافر يختارنا لا يجد فقط رحلة، بل ممراً آمناً ومريحاً
                  ومليئاً بالاحترام والعناية التي تستحقها هذه الرحلة المهمة.
                </p>

                <div className="row">
                  <p><b>لماذا تختار الحرمين؟</b></p>
                  <div className="col-md-6">
                    <ul>
                      <li>دعم مخصص لرحلات الحج والعمرة</li>
                      <li>فهم ثقافي عميق</li>
                      <li>راحة لا مثيل لها</li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul>
                      <li>سائقون محترمون ومحترفون</li>
                      <li>التزام بالتميز</li>
                    </ul>
                  </div>
                </div>

                <div className="row">
                  <p><b>انضم إلينا</b></p>
                  <p>
                    ابدأ رحلتك مع خدمة الحرمين كاب واكتشف تجربة سفر تتميز بالعناية والكرامة والإخلاص.
                    اتركوا لنا أمر الرحلة، حتى تتمكنوا من التركيز على اللحظات التي تهم حقاً.
                    <br />
                    للحجوزات والمزيد من المعلومات، زوروا موقعنا أو تواصلوا معنا مباشرة. رحلتكم إلى قلب الإيمان تبدأ هنا.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section services bg-light-primary">
        <div className="service-right">
          <ImageWithBasePath
            src="/assets/img/bg/service-right.svg"
            className="img-fluid"
            alt="services right"
          />
        </div>
        <div className="container">
          <div className="section-heading" data-aos="fade-down">
            <h2>كيف تعمل الخدمة</h2>
            <p>
              تُبسّط الحرمين كاب رحلة حجكم أو عمرتكم بالتركيز على الراحة والأمان والسكينة الروحية.
              هكذا تعمل خدمتنا بخطوات بسيطة
            </p>
          </div>
          <div className="services-work">
            <div className="row">
              <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                <div className="services-group">
                  <div className="services-icon border-secondary">
                    <ImageWithBasePath
                      className="icon-img bg-secondary"
                      src="/assets/img/icons/booking.svg"
                      alt="احجز رحلتك"
                    />
                  </div>
                  <div className="services-content">
                    <h3>1. احجز رحلتك</h3>
                    <p>
                      استخدم موقعنا أو تطبيق الهاتف لاختيار تفاصيل رحلتك.
                      اختر التاريخ والوقت والوجهة لرحلتك.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                <div className="services-group">
                  <div className="services-icon border-warning">
                    <ImageWithBasePath
                      className="icon-img bg-warning"
                      src="/assets/img/icons/confirmation.svg"
                      alt="استلم التأكيد"
                    />
                  </div>
                  <div className="services-content">
                    <h3>2. استلم التأكيد</h3>
                    <p>
                      ستحصل على رسالة تأكيد تحتوي على تفاصيل السائق والوقت المتوقع للوصول.
                      تضمن هذه الرسالة أن كل شيء جاهز لرحلتك.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                <div className="services-group">
                  <div className="services-icon border-dark">
                    <ImageWithBasePath
                      className="icon-img bg-dark"
                      src="/assets/img/icons/ejoy-ride.svg"
                      alt="استمتع برحلتك"
                    />
                  </div>
                  <div className="services-content">
                    <h3>3. استمتع برحلتك</h3>
                    <p>
                      سيصل سائقك في الوقت المحدد، جاهزاً لأخذك إلى وجهتك.
                      الرحلة مريحة وآمنة وتحترم تجربة حجك أو عمرتك.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section facts-number">
        <div className="facts-left">
          <ImageWithBasePath
            src="/assets/img/bg/facts-left.png"
            className="img-fluid"
            alt="facts left"
          />
        </div>
        <div className="facts-right">
          <ImageWithBasePath
            src="/assets/img/bg/facts-right.png"
            className="img-fluid"
            alt="facts right"
          />
        </div>
        <div className="container">
          <div className="section-heading" data-aos="fade-down">
            <h2 className="title text-white">حقائق بالأرقام</h2>
            <p className="description text-white">
              تقف هذه الأرقام كدليل ثابت على إنجازاتنا والأثر الملموس الذي نحققه.
            </p>
          </div>
          <div className="counter-group">
            <div className="row">
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="/assets/img/icons/Good-review.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={16000}
                          duration={3}
                          separator=","
                        />
                        K<br />
                      </h4>
                      <p>عميل سعيد</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="/assets/img/icons/Sedan-car-front.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={250}
                          duration={3}
                          separator=","
                        />
                        +<br />
                      </h4>
                      <p>عدد السيارات</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="/assets/img/icons/Solution.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={625}
                          duration={3}
                          separator=","
                        />
                        K+
                        <br />
                      </h4>
                      <p>حلول مركز السيارات</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="/assets/img/icons/Distance.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={200}
                          duration={3}
                          separator=","
                        />
                        K+
                        <br />
                      </h4>
                      <p>إجمالي الكيلومترات</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section why-choose">
        <div className="choose-left">
          <ImageWithBasePath
            src="/assets/img/bg/choose-left.png"
            className="img-fluid"
            alt="لماذا تختارنا"
          />
        </div>
        <div className="container">
          <div className="section-heading" data-aos="fade-down">
            <h2>لماذا تختارنا</h2>
            <p>
              تقدم خدمة الحرمين كاب نقلاً مخصصاً للمعتمرين والمسافرين في جميع أنحاء المملكة العربية السعودية،
              مع مجموعة واسعة من المسارات، وأسطول سيارات متنوع، وسائقين محترفين.
              معروفة برضا العملاء العالي، والعمل على مدار الساعة طوال أيام الأسبوع، والدعم متعدد اللغات،
              تركز الشركة على الاستدامة البيئية والمشاركة المجتمعية، مما يرسخ حضوراً بارزاً في الصناعة.
            </p>
          </div>
          <div className="why-choose-group">
            <div className="row">
              <div
                className="col-lg-4 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-black">
                      <ImageWithBasePath
                        src="/assets/img/icons/easy.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>حجز سريع وسهل</h4>
                      <p>
                        صُممت عملية الحجز لدينا لتكون سهلة وسريعة، مما يضمن لك الحصول على خدماتنا
                        بأقل مجهود وأعلى كفاءة.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-secondary">
                      <ImageWithBasePath
                        src="/assets/img/icons/expert.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>خبرة ومعرفة</h4>
                      <p>
                        معرفة فريقنا العميقة وسنوات خبرته تضمن فهمنا لتفاصيل احتياجاتك،
                        وتقديم حلول فعالة وكفؤة.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-primary">
                      <ImageWithBasePath
                        src="/assets/img/icons/Trust.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>الموثوقية والثقة</h4>
                      <p>
                        مبنية على أساس من الثقة والموثوقية، نفتخر بكوننا شريكاً يمكنك الاعتماد عليه،
                        نلتزم بوعودنا ونضمن راحة بالك.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section about-testimonial testimonials-section">
        <div className="container">
          <div className="section-heading" data-aos="fade-down">
            <h2 className="title text-white">ماذا يقول الناس عنا؟</h2>
            <p className="description text-white">
              يقول المسافرون السعداء أننا نجعل رحلتهم الخاصة أفضل. يحبون كيف نهتم بكل التفاصيل،
              مما يجعل رحلتهم سهلة وهادئة. إنهم ممتنون لمساعدتنا اللطيفة والدقيقة، ويخبرون الآخرين
              بأننا خيار رائع لرحلة خالية من القلق.
            </p>
          </div>
          <div className="owl-carousel about-testimonials testimonial-group mb-0 owl-theme">
            <Slider {...settings}>
              {testimonials.map((testimonial) => (
                <div key={testimonial.id} className="testimonial-item d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="quotes-head" />
                      <div className="review-box">
                        <div className="review-profile">
                          <div className="review-img">
                            <ImageWithBasePath
                              src={testimonial.image}
                              className="img-fluid"
                              alt="img"
                            />
                          </div>
                        </div>
                        <div className="review-details">
                          <h6>{testimonial.name}</h6>
                          <div className="list-rating">
                            <div className="list-rating-star">
                              {[...Array(Math.floor(testimonial.rating))].map(
                                (_, i) => (
                                  <i key={i} className="fas fa-star filled" />
                                )
                              )}
                            </div>
                            <p>
                              <span>({testimonial.rating})</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <p>{testimonial.review}</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
      <>
        <section className="section faq-section bg-light-primary">
          <div className="container">
            <div className="section-heading" data-aos="fade-down">
              <h2>الأسئلة الشائعة</h2>
            </div>
            <div className="faq-info">
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    href="#faqOne"
                    aria-expanded="false"
                  >
                    كيف يمكنني حجز رحلة العمرة معكم؟
                  </Link>
                </h4>
                <div id="faqOne" className="card-collapse collapse">
                  <p>
                    يمكنك حجز رحلتك من خلال موقعنا الإلكتروني أو تطبيق الهاتف. اختر الباقة التي تريدها، أدخل بياناتك، واختر طريقة الدفع. سيتم إرسال تأكيد الحجز إليك فوراً بعد إتمام الحجز.
                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    href="#faqTwo"
                    aria-expanded="false"
                  >
                    ما أنواع الباقات التي تقدمونها لرحلة العمرة؟
                  </Link>
                </h4>
                <div id="faqTwo" className="card-collapse collapse">
                  <p>
                    نقدم مجموعة متنوعة من الباقات لتناسب احتياجات وميزانيات مختلفة، تشمل باقات أساسية ومميزة وفاخرة. تشمل كل باقة السفر والإقامة ومعالجة التأشيرة، مع تفاصيل كاملة متوفرة على موقعنا.
                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    href="#faqThree"
                    aria-expanded="false"
                  >
                    هل يمكنكم تلبية الطلبات أو الاحتياجات الخاصة؟
                  </Link>
                </h4>
                <div id="faqThree" className="card-collapse collapse">
                  <p>
                    نعم، نسعى لتلبية جميع الطلبات الخاصة، بما في ذلك القيود الغذائية، وإمكانية الوصول لذوي الإعاقة، وأي احتياجات شخصية أخرى. يرجى ذكر متطلباتك عند الحجز وسنبذل قصارى جهدنا لتلبيتها.
                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    href="#faqFour"
                    aria-expanded="false"
                  >
                    ما الذي يشمله سعر باقة العمرة؟
                  </Link>
                </h4>
                <div id="faqFour" className="card-collapse collapse">
                  <p>
                    بشكل عام، تشمل باقاتنا معالجة التأشيرة، الطيران، الإقامة في الفنادق، النقل داخل السعودية، والوجبات. تختلف التفاصيل المحددة حسب الباقة، لذا يرجى مراجعة وصف الباقة أو التواصل معنا لمزيد من المعلومات.
                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    href="#faqFive"
                    aria-expanded="false"
                  >
                    متى يجب أن أحجز رحلة العمرة؟
                  </Link>
                </h4>
                <div id="faqFive" className="card-collapse collapse">
                  <p>
                    نوصي بالحجز قبل موعد الرحلة بأسبوعين على الأقل، خاصة في المواسم المزدحمة، لضمان أفضل الأسعار والتوافر. ومع ذلك، يمكننا استيعاب الحجوزات في اللحظة الأخيرة حسب التوافر.
                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    href="#faqSix"
                    aria-expanded="false"
                  >
                    هل يوجد مرشد أو مساعدة متاحة خلال رحلة العمرة؟
                  </Link>
                </h4>
                <div id="faqSix" className="card-collapse collapse">
                  <p>
                    نعم، تشمل باقاتنا خدمات مرشدين ذوي خبرة على دراية بمناسك العمرة ويمكنهم تقديم المساعدة خلال رحلتك.
                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    href="#faqSeven"
                    aria-expanded="false"
                  >
                    ما هي سياسة الإلغاء الخاصة بكم؟
                  </Link>
                </h4>
                <div id="faqSeven" className="card-collapse collapse">
                  <p>
                    تختلف سياسة الإلغاء حسب الباقة. بشكل عام، الإلغاءات التي تتم خلال فترة معينة قبل السفر قد تكون مؤهلة لاسترداد كامل أو جزئي. يرجى مراجعة الشروط والأحكام الخاصة بباقتك للحصول على تفاصيل كاملة.
                  </p>
                </div>
              </div>

              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    href="#faqEight"
                    aria-expanded="false"
                  >
                    كيف أستعد لرحلة العمرة؟
                  </Link>
                </h4>
                <div id="faqEight" className="card-collapse collapse">
                  <p>
                    نوفر لجميع المسافرين دليلاً شاملاً حول كيفية الاستعداد للعمرة، يشمل الوثائق المطلوبة، الملابس الموصى بها، والاستعداد الروحي. فريقنا متاح أيضاً للإجابة على أي أسئلة قد تكون لديك.
                  </p>
                </div>
              </div>
            </div>

            <div className="faq-card bg-white" data-aos="fade-down">
              <h4 className="faq-title">
                <Link
                  className="collapsed"
                  data-bs-toggle="collapse"
                  href="#faqNine"
                  aria-expanded="false"
                >
                  هل خيارات الطيران والإقامة مرنة؟
                </Link>
              </h4>
              <div id="faqNine" className="card-collapse collapse">
                <p>
                  نعم، نقدم مجموعة من خيارات الطيران والإقامة لتناسب التفضيلات والميزانيات المختلفة. يمكنك اختيار شركة الطيران والفندق عند حجز باقتك.
                </p>
              </div>
            </div>

            <div className="faq-card bg-white" data-aos="fade-down">
              <h4 className="faq-title">
                <Link
                  className="collapsed"
                  data-bs-toggle="collapse"
                  href="#faqTen"
                  aria-expanded="false"
                >
                  كيف يمكنني التواصل معكم لمزيد من الأسئلة؟
                </Link>
              </h4>
              <div id="faqTen" className="card-collapse collapse">
                <p>
                  يمكنك التواصل معنا من خلال نموذج التواصل على موقعنا، البريد الإلكتروني، أو الهاتف. فريق خدمة العملاء لدينا متاح على مدار الساعة طوال أيام الأسبوع لمساعدتك في أي استفسارات.
                </p>
              </div>
            </div>
          </div>
        </section>
      </>
    </>
  );
};

export default ArAbout;
